module.exports = __webpack_public_path__ + "img/oran_2kl.cf822b18.jpg";